export interface Picture {
  userId: number;
  id?: number;
  private: number;
  main: number;
  explicit: number;
  thumb: string;
  large: string;
}

export const createDefaultPicture = (userId: number, gender: string): Picture => ({
  userId,
  private: 0,
  main: 1,
  explicit: 0,
  thumb: `http://whitelabel.local/images/no-picture/360/${gender}_no_picture.png`,
  large: `http://whitelabel.local/images/no-picture/1920/${gender}_no_picture.png`,
});